import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import TravelOverview from '../v2/pages/Travel/TravelOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'

export const travelBaseUrl = '/travel/:action?'

export default function Travels(props: EntityPageProps): ReactElement {
    return (
        <EntityPage {...props} baseUrl={travelBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <Switch>
                    <Route
                        path={route}
                        render={(routeProps: RouteComponentProps) => (
                            <TravelOverview
                                {...routeProps}
                                fileId={props.currentFile?.id}
                                baseUrl={baseUrl}
                                localStorageKeyPrefix={`HammockTravelOverview-${props.currentFile?.id}-`}
                            />
                        )}
                    />
                </Switch>
            )}
        </EntityPage>
    )
}
